import styles from '@/styles/header.module.scss';
import { useLocalization } from '@/hooks/useLocalization';
import { useWidget } from '@/state/WidgetContext';
import { SCREENS } from '@/utils/constants';

const LangIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" /></svg>
);
const MinusIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M19 13H5v-2h14v2z" /></svg>
);
const CloseIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" /></svg>
);

export default function Header({ onMinimize, onClose }) {
  const { t } = useLocalization();
  const { goTo } = useWidget();

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <div className={styles.logoMark}>IBC</div>
        <div>
          <div className={styles.title}>{t('header.title')}</div>
          <div className={styles.subtitle}>{t('header.subtitle')}</div>
        </div>
      </div>
      <div className={styles.controls}>
        <button
          className={styles.btn}
          onClick={() => goTo(SCREENS.LANGUAGE)}
          title={t('header.changeLanguage')}
          aria-label={t('header.changeLanguage')}
          type="button"
        >
          <LangIcon />
        </button>
        <button className={styles.btn} onClick={onMinimize} title="Minimize" type="button">
          <MinusIcon />
        </button>
        <button className={styles.btn} onClick={onClose} title="Close" type="button">
          <CloseIcon />
        </button>
      </div>
    </header>
  );
}
